// 公告管理
export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    //登录前公告
    loginBeforeAnnounceData: function loginBeforeAnnounceData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "loginBeforeAnnounceData",
        method: "get",
        params: data
      });
    },
    loginBeforeAnnounceAdd: function loginBeforeAnnounceAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "loginBeforeAnnounceAdd",
        method: "post",
        params: data
      });
    },
    loginBeforeAnnounceUpdate: function loginBeforeAnnounceUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "loginBeforeAnnounceUpdate",
        method: "post",
        params: data
      });
    },
    loginBeforeAnnounceDel: function loginBeforeAnnounceDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "loginBeforeAnnounceDel",
        method: "post",
        params: data
      });
    },
    //游戏内公告
    gameAnnounceData: function gameAnnounceData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "gameAnnounceData",
        method: "get",
        params: data
      });
    },
    gameAnnounceAdd: function gameAnnounceAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "gameAnnounceAdd",
        method: "post",
        params: data
      });
    },
    gameAnnounceDel: function gameAnnounceDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "gameAnnounceDel",
        method: "post",
        params: data
      });
    },
    gameAnnounceUpdate: function gameAnnounceUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "gameAnnounceUpdate",
        method: "post",
        params: data
      });
    },
    // 服务器状态
    serverStateData: function serverStateData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "serverStateData",
        method: "get",
        params: data
      });
    },
    serverStateAdd: function serverStateAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "serverStateAdd",
        method: "post",
        params: data
      });
    },
    serverStateUpdate: function serverStateUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "serverStateUpdate",
        method: "post",
        params: data
      });
    },
    serverStateDel: function serverStateDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "serverStateDel",
        method: "post",
        params: data
      });
    },
    announceTypeChangeSort: function announceTypeChangeSort() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "announceTypeChangeSort",
        method: "post",
        data: data
      });
    },
    announceChangeSort: function announceChangeSort() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "announceChangeSort",
        method: "post",
        data: data
      });
    }
  };
});